import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { Cache } from "~/types/cache";
import { Locale } from "~/types/locale";

import {
  messagePage,
  setMessageSetting,
  messageState,
  getMessageSetting,
} from "~/apis/messages";
import { useAccountStore } from "~/store/account";
const PAGE_SIZE = 20;

export const useMessages = defineStore(Cache.MESSAGE, () => {
  const { $i18n } = useNuxtApp();
  const { t, locale } = $i18n;
  const accountStore = useAccountStore();
  const isLogin = computed(() => !!accountStore.access_token);
  const messages = ref({
    default: {
      list: [],
    },
    // 3 系统消息
    system: {
      list: [],
      pageNo: 1,
      total: 0,
    },
    // 4 关注动态
    follow: {
      list: [],
      pageNo: 1,
      total: 0,
    },
    // 5 评论动态
    comment: {
      list: [],
      pageNo: 1,
      total: 0,
    },
  });
  const messagesSetting = ref<any>({
    messageNotify: 0,
    systemMessageNotify: 0,
    followingMessageNotify: 0,
    commentMessageNotify: 0,
    messageUnread: false,
  });
  const messagesState = ref<any>({
    systemMessageUnreadNum: 0,
    followingMessageUnreadNum: 0,
    commentMessageUnreadNum: 0,
    messageUnread: false,
  });

  const currentLocale = computed(() => {
    switch (locale.value) {
      case Locale.EN:
        return "en";
      case Locale.ZH_CN:
        return "cn";
      default:
        return "en";
    }
  });

  /** 获取消息列表 */
  const getMessages = async (e) => {
    if (!isLogin.value) return;
    try {
      const postData = {
        langCode: currentLocale.value,
        pageSize: PAGE_SIZE,
        ...e,
      };
      const response = await messagePage(postData);
      if (response.code === 0) {
        switch (e.templateType) {
          case 3: // 系统消息
            messages.value.system.total = response.data.total;
            if (e.pageNo === 1) {
              messages.value.system.list = response.data.list;
            } else {
              messages.value.system.list = messages.value.system.list.concat(
                response.data.list
              );
            }
            break;
          case 4: // 关注动态
            messages.value.follow.total = response.data.total;
            if (e.pageNo === 1) {
              messages.value.follow.list = response.data.list;
            } else {
              messages.value.follow.list = messages.value.follow.list.concat(
                response.data.list
              );
            }
            break;
          case 5: // 评论动态
            messages.value.comment.total = response.data.total;
            if (e.pageNo === 1) {
              messages.value.comment.list = response.data.list;
            } else {
              messages.value.comment.list = messages.value.comment.list.concat(
                response.data.list
              );
            }
            break;
          default:
            messages.value.default.list = response.data.list;
            break;
        }
      } else {
      }
    } catch (error) {
      console.log("getMessages; error:", error);
    }
  };

  /** 获取消息状态 */
  const getMessagesState = async () => {
    if (!isLogin.value) return;
    try {
      const response = await messageState();
      if (response.code === 0) {
        messagesState.value = response.data;
      }
      //;
      else {
      }
    } catch (error) {
      console.log("getMessagesState; error:", error);
    }
  };

  /** 获取消息状态 */
  const getMessagesSetting = async () => {
    if (!isLogin.value) return;
    try {
      const response = await getMessageSetting();
      if (response.code === 0) {
        messagesSetting.value = response.data;
      }
      //;
      else {
      }
    } catch (error) {
      console.log("getMessagesState; error:", error);
    }
  };

  /** 设置消息状态 */
  const setMessagesSetting = async (params) => {
    if (!isLogin.value) return;
    console.log("setMessagesState; params:", params);
    try {
      const response = await setMessageSetting(params);
      console.log("setMessagesState; response:", response);
      if (response.code === 0) {
        messagesSetting.value = response.data;
        messagesState.value.messageUnread = response.data.messageUnread;
      } else {
      }
    } catch (error) {
      console.log("getMessagesState; error:", error);
    }
  };

  return {
    messages,
    messagesState,
    messagesSetting,
    getMessages,
    getMessagesState,
    setMessagesSetting,
    getMessagesSetting,
  };
});
